module.exports = __webpack_public_path__ + "img/16k016-03.2ae8f89d.png";